import { render, staticRenderFns } from "./SafTab.vue?vue&type=template&id=10bbcddc"
import script from "./SafTab.vue?vue&type=script&lang=js"
export * from "./SafTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports